import { Modal, Form, Title } from '@bancobarigui/barihaus';
import { CloseOutlined } from '@ant-design/icons';
import { useEffect } from 'react';

import { AttachmentForm } from './AttachmentForm';
import { ModalFooter } from '@/components/ModalFooter';

import { AttachmentData, useAttachmentModal } from './useAttachmentModal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: AttachmentData) => void;
  initialData?: Partial<AttachmentData> | undefined;
};

export function AttachmentModal({ open, onClose, onSubmit, initialData }: Props) {
  const {
    form,
    selectedFile,
    formatFileSize,
    handleFileChange,
    handleRemoveFile,
    handleFormSubmit,
  } = useAttachmentModal({
    onClose,
    onSubmit,
  });

  useEffect(() => {
    if (open && initialData) {
      form.setFieldsValue({
        description: initialData.description,
        fileType: initialData.fileType,
      });
    } else if (!open) {
      form.resetFields();
    }
  }, [open, initialData, form]);

  return (
    <Modal
      centered
      open={open}
      width={700}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <Title level={2}>{initialData ? 'Editar Anexo' : 'Adicionar Anexo'}</Title>

      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <AttachmentForm
          selectedFile={selectedFile}
          formatFileSize={formatFileSize}
          handleFileChange={handleFileChange}
          handleRemoveFile={handleRemoveFile}
        />

        <ModalFooter onClose={onClose} />
      </Form>
    </Modal>
  );
}
